import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { IScreenOrderItem } from 'utils/buildFlowTransitions';
import { Screens } from '@shared/constants/screens';
import { ScreenConfig } from '@config/default.config';
import { AppAction, appReducer, AppState, initialAppState } from './appReducer';

export type FlowTransitions = Partial<Record<Screens, ScreenConfig>>;
interface AppContextType {
  appState: AppState;
  appDispatch: React.Dispatch<AppAction>;
  screenOrder: IScreenOrderItem[];
  flowTransitions: FlowTransitions;
}

interface AppProviderProps {
  children: ReactNode;
}

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [appState, appDispatch] = useReducer(appReducer, initialAppState);

  const value = {
    appState,
    appDispatch,
    screenOrder: appState.screenOrder,
    flowTransitions: appState.flowTransitions
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
